import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import swal from "sweetalert2";

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit {

  rows = [];
  constructor(public apiService: ApiService,
    private spinner: NgxSpinnerService,
    public toastr: ToastrService,private route : Router) { }

  ngOnInit(): void {
    this.getCourseList()
  }
  getCourseList() {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
   
    this.apiService
      .getCourseGroupingListByCategory("current","666ff4a345e46a530ce03650","",1,20)
      .subscribe((res: any) => {
        this.spinner.hide();
        let data = res?.data?.items.map((item) => item.course);
        this.rows = data.flat()
      });
  }
  goToDetail(password, id, coursePasswordValue) {
    if (password === coursePasswordValue) {
      window.open(`/student-lms?id=${id}`, "_blank");
    }
    else {
      swal.fire({
            icon: "error",
            title: "Error!",
            text: "Incorrect Password!",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
    }
  }
  confirmUpdate(id: any, course_password) {
    if (course_password == '' || course_password == null || course_password == undefined) { 
      window.open(`/student-lms?id=${id}`, "_blank");
    }
    else {
      swal
      .fire({
        text: "Please Enter Read Password",
        input: "password",
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          this.goToDetail(result.value,id,course_password);
        }
        else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: "Cancelled",
            text: "Cancel",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });  
    }
  }

}
